/* index.js */

"use strict";
// const _ = require("lodash");

module.exports = {
    actionGroupFormatter,
    dateFormatter,
    defaultFormatter,
    actionButtonsFormatter,
    createdByFormatter,
    nameFormatter,
};

function actionGroupFormatter(row, cell, value, columnDef) {
    // console.log(row, cell, value, columnDef, dataContext);
    const actionGroupEl = document.createElement("div");
    actionGroupEl.classList.add("general-column");
    const actionGroupVal = columnDef.values.find((i) => i.value === value);
    actionGroupEl.setAttribute("title", actionGroupVal.label || "Action group not Available");
    actionGroupEl.innerHTML = actionGroupVal.label || "Action group not Available";
    return actionGroupEl.outerHTML;
}

function nameFormatter(row, cell, value) {
    const nameEl = document.createElement("div");
    nameEl.classList.add("general-column");
    nameEl.classList.add("name-column");
    // if (dataContext.dirty === true) {
    //     nameEl.classList.add("dirty-rule");
    // }
    nameEl.setAttribute("title", value);
    nameEl.innerHTML = value;
    return nameEl.outerHTML;
}

function dateFormatter(row, cell, value) {
    let convertedDate = new Date(value).toLocaleDateString();
    const convertedDateEl = document.createElement("div");
    convertedDateEl.classList.add("date-column");
    let titleString = "";
    if (value === 0) {
        convertedDate = "N/A";
        titleString = "N/A";
    } else {
        titleString = convertedDate + " " + new Date(value).toLocaleTimeString();
    }

    convertedDateEl.setAttribute("title", titleString);
    convertedDateEl.innerHTML = convertedDate;
    return convertedDateEl.outerHTML;
}

function defaultFormatter(row, cell, value) {
    const createdByEl = document.createElement("div");
    createdByEl.classList.add("general-column");

    createdByEl.setAttribute("title", value);
    createdByEl.innerHTML = value;
    return createdByEl.outerHTML;
}

function createdByFormatter(row, cell, value, columnDef) {
    return defaultFormatter(row, cell, columnDef.value);
}

function actionButtonsFormatter(row, cell, value, columnDef, dataContext) {
    // const revealButton = document.createElement("base-icon-gl");
    // revealButton.dataset.icon = "common.eye";
    // revealButton.setDarkTheme(true);

    // revealButton.setAttribute("aria-label", `reveal ${dataContext.name}`);
    // revealButton.setAttribute("role", "button");

    // revealButton.dataset.uuid = dataContext.clientId;
    // revealButton.dataset.id = dataContext.id;
    // revealButton.dataset.action = "reveal";

    const deleteButton = document.createElement("base-icon-gl");
    deleteButton.dataset.icon = "common.trash_bin";
    deleteButton.setDarkTheme(true);

    deleteButton.setAttribute("aria-label", `delete ${dataContext.name}`);
    deleteButton.setAttribute("role", "button");

    deleteButton.dataset.uuid = dataContext.clientId;
    deleteButton.dataset.id = dataContext.id;
    deleteButton.dataset.action = "delete";

    const container = document.createElement("div");
    container.classList.add("actions-column");
    // container.appendChild(revealButton);
    container.appendChild(deleteButton);

    return container.outerHTML;
}
